import ajax from '@/utils/ajax';

export const head = '/web';




//通过推荐位id获取图书商城产品、套餐列表
export const reqBookMallList= (params) => ajax(`${head}/v1/home-recommend/book-mall-list`,params,'post');


// 获取用户搜索商品服务历史记录
export const reqSearchHistoryList= (homeRecommendId) => ajax(`${head}/v1/goods-search/search-user-history-list?homeRecommendId=${homeRecommendId}`);


// 删除用户搜索商品服务历史记录
export const reqDelSearchHistory= (data) => ajax(`${head}/v1/goods-search/search-user-history-delete`,data,'PUT');


